import { useEffect, useState } from 'react'
import { apiBase } from './lib/api'
import { useParams, useNavigate } from 'react-router-dom'
import { IconHeart } from './components/ui/Icons'

const API = apiBase

export default function DemoGate() {
  const { token } = useParams()
  const navigate  = useNavigate()
  const [status, setStatus] = useState('loading') // loading | error
  const [msg, setMsg]       = useState('')

  useEffect(() => {
    fetch(`${API}/demo/${token}`)
      .then(async res => {
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`)
        localStorage.setItem('polar_token', data.token)
        localStorage.setItem('polar_user', JSON.stringify({
          id: `demo-${token}`, email: 'demo@manabi.cagliero.ar',
          name: 'Demo', plan: 'familiar', demo: true,
          demoExpiresAt: data.expiresAt,
        }))
        navigate('/app/monitor', { replace: true })
      })
      .catch(err => {
        setMsg(err.message)
        setStatus('error')
      })
  }, [token, navigate])

  return (
    <div style={{
      minHeight: '100vh', background: '#07070f', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 24,
      fontFamily: '-apple-system,BlinkMacSystemFont,"SF Pro Display",sans-serif',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 380 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <IconHeart size={48} color="#ef4444" fill="#ef4444" />
        </div>
        {status === 'loading' ? (
          <>
            <div style={{
              width: 36, height: 36, border: '3px solid rgba(239,68,68,0.2)',
              borderTopColor: '#ef4444', borderRadius: '50%',
              animation: 'spin 0.8s linear infinite', margin: '0 auto 20px',
            }} />
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>Activando tu acceso demo…</p>
          </>
        ) : (
          <>
            <p style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 12 }}>Link no disponible</p>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, marginBottom: 28 }}>{msg}</p>
            <button
              onClick={() => navigate('/')}
              style={{ background: '#ef4444', border: 'none', color: '#fff', fontSize: 14, fontWeight: 700, padding: '12px 28px', borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Ir al inicio
            </button>
          </>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
